<template>
  <div
    class="oss-upload"
    :class="{
      drag: props.drag
    }"
  >
    <el-upload
      ref="upload"
      v-model:file-list="fileList"
      class="oss-el-upload"
      v-bind="props"
      :before-upload="handleBeforeUpload"
      :http-request="handleHttpRequest"
      :on-exceed="handleExceed"
      :before-remove="handleBeforeRemove"
      :on-success="handleSuccess"
    >
      <div v-if="props.drag">
        <img
          src="https://s1.longfor.com/image/3d16eb42d9b2c12aa5547d221aad096e.png"
        />
        <div class="el-upload__text">
          将图片/文件拖拽至此区域，或点击上传
        </div>
      </div>
      <div
        v-else
        class="btn-upload"
      >
        <el-button :disabled="disabled" type="default" :icon="Plus">上传文件</el-button>
      </div>

      <template #tip>
        <div
          class="el-upload__tip"
        >
          {{ props.tip }}
        </div>
      </template>
      <template #file="{ file }">
        <div class="file-item">
          <div class="file-info">
            <div class="file-name">
              {{ file.name  }}
            </div>
            <template v-if="file.id">
              <span class="btns el-upload-list__item-status-label">
                <el-icon class="el-icon--upload-success el-icon--circle-check" color="#67c23a"><CircleCheck /></el-icon>
              </span>
              <el-icon class="el-icon--close" @click="handleRemove(file)"><CircleClose /></el-icon>
            </template>
            <el-icon v-else><Loading /></el-icon>
          </div>

          <el-progress
            v-if="progressList[file.uid] || progressList[file.uid] === 0"
            :stroke-width="10"
            striped
            :percentage="progressList[file.uid]"
          ></el-progress>
        </div>
      </template>
    </el-upload>

  </div>
</template>

  <script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { ossSts } from '@/api/modules/user';
  import type {
    UploadRawFile, UploadUserFile, UploadFile, UploadFiles, UploadRequestOptions
    } from 'element-plus';
  import { ElMessage, genFileId } from 'element-plus';
  import {CircleCheck, CircleClose, Loading, Plus} from "@element-plus/icons-vue";
  import OSS from 'ali-oss';
  import {checkFileFormat} from "@/utils";
  import {getUploadFile} from "@/api/modules/upload";

  interface UploadOssFile {
    fileName: string,
    ossName: string,
    ossUrl: string
  }

  interface OssUploadProps {
    drag?: boolean,
    disabled?: boolean,
    multiple?: boolean,
    maxFileSize?: number, // 单位：兆(m)
    tip?: string,
    files?: Array<UploadUserFile>,
    onFileUploaded?: ((file: UploadOssFile) => Array<UploadUserFile>) | null
    onFileRemove?: ((file: UploadUserFile) => boolean) | null
    getFileList?: ((file: any) => boolean) | null
  }

  const props = withDefaults(defineProps<OssUploadProps>(), {
    drag: false,
    disabled: false,
    multiple: false,
    maxFileSize: 20,
    tip: '',
    files: () => [],
    onFileUploaded: null,
    onFileRemove: null,
    getFileList: null,
  });

  // const emits = defineEmits(['fileUploaded']);

  const upload = ref<any>();

  const fileList = ref<UploadUserFile[]>([]);

  watch(
    () => props.files,
    (newFiles) => {
      fileList.value = [];

      if (newFiles.length) {
        fileList.value = newFiles.map((file) => ({
          ...file,
          name: file.fileName || '',
          url: file.fileUrl,
        }));
        // 暴露 fileList
        getFileList()
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
  // const loading = ref(false);
  const progressList = ref({}) as any;
  function getFileList() {
    if (typeof props.getFileList === 'function') {
      props.getFileList(fileList.value)
    }
  }

  async function uploadToOSS(file: File) {
    try {
      const fm = new FormData()
      fm.append('file',file)
      fm.append('dir','idata/demand/delivery')
      const result = await getUploadFile(fm)
      console.log('getUploadFile----',result)
      if (result.code === '200'){
        console.log('getUploadFile----url',result.data)
        if (result.data) {
          return {
            fileName: file.name,
            ossName: result.data,
            ossUrl: result.data
          };
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  async function uploadToOSS2(file: File) {
    try {
      const res = await ossSts();
      if (res.code === '200') {
        const stsInfo = res.data;

        const client = new OSS({
          // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
          region: stsInfo.regionId,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
          accessKeyId: stsInfo.accessKeyId,
          accessKeySecret: stsInfo.accessKeySecret,
          // 从STS服务获取的安全令牌（SecurityToken）。
          stsToken: stsInfo.securityToken,
          // 填写Bucket名称。
          bucket: stsInfo.bucketName,
        });

        const fileName = `idata/demand/delivery/file-${genFileId()}_${file.name}`;
        const fileId = file as any;
        const result = await client.multipartUpload(fileName, file, {
          progress: (p: any) => {
            // console.log(p);
            // progress.value = Number((p * 100).toFixed(0));
            progressList.value[fileId.uid] = Number((p * 100).toFixed(0));
          }
        });
        // let result2 = await client.head(fileName);
        // let result = await client.put(fileName, file)
        console.log('file uploaded: ', result);
        const url = result.res as any;
        // emits('fileUploaded', result.url);
        return {
          fileName: file.name,
          ossName: result.name,
          // ossUrl: result.url,
          ossUrl: url?.requestUrls[0]
        };
      }
    } catch (e) {
      console.log(e);
    }
  }

  function handleBeforeUpload(file: UploadRawFile) {
    console.log('file----',file)
    if (!checkFileFormat(file,'')){
      ElMessage.error('当前仅支持：word、excel、csv、ppt、pdf、txt、jpg、png、zip格式的文件上传');
      return false;
    }
    // const maxFileSize = props.maxFileSize || 20;
    const maxFileSize = 20;
    console.log('maxFileSize--',maxFileSize)
    const isExceeded = file.size > 1024 * 1024 * maxFileSize;
    console.log('isExceeded--',isExceeded)
    if (isExceeded) {
      ElMessage.error(`所选文件单个超过${maxFileSize}M，已自动过滤，请检查~`);
      return false;
    }

    return true;
  }

  async function handleHttpRequest(options: UploadRequestOptions) {
    // loading.value = true
    console.log(options);
    // await uploadToOSS(options.file);

    const file = options.file;
    progressList.value[file.uid] = 0;
    const onSuccess = options.onSuccess;
    const onError = options.onError;

    const uploadedFile: UploadOssFile | undefined = await uploadToOSS(file);
    // console.log(progressList.value);
    delete progressList.value[file.uid];
    if (!uploadedFile) {
      return onError(new Error('文件上传失败') as any);
    }

    if (typeof props.onFileUploaded === 'function') {
      const savedFiles = await props.onFileUploaded(uploadedFile);

      if (savedFiles && savedFiles.length > 0) {
        const savedFile = savedFiles[0];

        onSuccess(savedFile);
      } else {
        onError(new Error('文件保存失败') as any);
      }
    } else {
      onSuccess(uploadedFile);
    }
  }

  const handleSuccess = (res: any, file: any, files: UploadFiles) => {
    if (res) {
      file.id = res.id;
      file.fileName = res.fileName;
      file.ossName = res.ossName;
      file.ossUrl = res.ossUrl;
      console.log('success: ', res, file, files);
      // 暴露 fileList
      getFileList()
      // loading.value = false
    }
  };

  const handleExceed = (/* files: UploadFiles */) => {
    // const file = files[0];
    // const isLt50M = file.size < 1024 * 1024 * 50;
    // if (!isLt50M) {
    //   ElMessage.error('所选文件单个超过50M，已自动过滤，请检查~');
    //   return;
    // }
    // upload.value?.clearFiles();
    // file.uid = genFileId();
    // upload.value?.handleStart(file);
    // handleHttpRequest({ file });
  };

  const handleBeforeRemove = async (file: UploadFile/* , files: UploadFiles */) => {
    if (typeof props.onFileRemove === 'function' && file) {
      const result = await props.onFileRemove(file as UploadUserFile);
      return result;
    }
    return true;
  };

  function handleRemove(file: UploadFile) {
    console.log('remove file: ', genFileId(), file, upload.value);
    upload.value!.handleRemove(file)
    setTimeout(() => {
      // 暴露 fileList
      getFileList()
    })
  }
  </script>
  <style lang="scss">
  .oss-upload {
    width: 100%;

    &.drage {
      :deep(.el-upload) {
        // width: 100%;
        // height: 112px;
        .el-upload__text {
          color: #007af5;
          font-size: 12px;
        }

        .el-upload-dragger {
          padding: 33px 0;
        }
      }
    }

    .el-upload-list__item-status-label{
      position: inherit;
    }

    .el-icon--close{
      position: inherit !important;
      transform: none;
    }

    .file-item{
      width: 100%;

      .file-info{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .file-name{
          flex: 1;
          overflow: hidden;
          font-size: 12px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .btns{
        display: flex;
        flex-shrink: 1;
        align-items: center;
        cursor: pointer;
      }

      .el-progress{
        position: inherit;

        .el-progress__text{
          position: inherit;
          display: flex;
          justify-content: flex-end;

          span{
            font-size: 12px;
          }
        }
      }
    }
  }
  </style>
